import { render, staticRenderFns } from "./SuggestTherapistsYEMSQ.vue?vue&type=template&id=d265f91c&scoped=true"
import script from "./SuggestTherapistsYEMSQ.vue?vue&type=script&lang=js"
export * from "./SuggestTherapistsYEMSQ.vue?vue&type=script&lang=js"
import style0 from "./SuggestTherapistsYEMSQ.vue?vue&type=style&index=0&id=d265f91c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d265f91c",
  null
  
)

export default component.exports